<div class="h-100 d-flex align-items-center" clickStopPropagation>
  <iris-dms-download-folder-button [folderId]="folderId()"
                                   [iconOnly]="true"
                                   [isMatMenu]="false"
                                   data-test="folder-grid-actions-button">
  </iris-dms-download-folder-button>

  @if (hasUpdatePermission() && !isProjectFolder()) {
    <iris-dms-edit-folder-button [folderId]="folderId()"
                                 [iconOnly]="true"
                                 [isMatMenu]="false"
                                 data-test="folder-grid-actions-button-2">
    </iris-dms-edit-folder-button>
  }

  @if (showActionsMenu()) {
    <iris-dms-folder-actions-menu class="d-flex"
                                  cssClass="grid-folder-actions-menu"
                                  [disabledActions]="disabledFolderActions"
                                  [folder]="folder()"
                                  data-test="folder-grid-actions-menu-item">
    </iris-dms-folder-actions-menu>
  }
</div>
